import { Component, inject } from '@angular/core';
import { faq } from 'src/app/configs/faq';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { LanguageService } from 'app/services';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: true,
  imports: [NgClass, TranslateModule],
})
export class FaqComponent {
  private languageService: LanguageService = inject(LanguageService);

  appears: boolean = false;
  data: {
    issue: string;
    reply: string;
    selected: boolean;
    link: string;
  }[] = faq;

  get supportSafeLink(): string {
    let lang: string = this.languageService.get();
    if (lang === 'fr-FR') lang = 'fr';
    if (lang === 'de-DE') lang = 'de';
    if (!['de', 'fr', 'en-us'].includes(lang)) lang = 'en-us';
    return `https://support.kinomap.com/hc/${lang}`;
  }
}
